import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    visible: false,
    type: null,
    settings: null
  }),
  actions: {
    setVisible(visible) {
      this.visible = visible
    },
    hide() {
      this.visible = false
      this.settings = null
    },
    apply() {
      if (this.settings.onApply) {
        this.settings.onApply(this.settings.payload)
      }
      this.visible = false
      this.settings = null
    },
    confirm(payload) {
      this.settings = payload
      this.type = 'confirm'
      this.visible = true
    },

    alert(payload) {
      this.settings = payload
      this.type = 'alert'
      this.visible = true
    }
  }
})
